export default __webpack_public_path__ + "static/gif-real-611138b9e1327ec66abd69e478cb3cba.gif";